/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_4threal/layout/core'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {
  copyFiles,
  deleteCard,
  getCards,
  getDeletedCards,
  getMarkers,
  updateCard,
} from '../../../redux/action/card'
import {useSelector} from 'react-redux'
import {userProfile} from '../../../redux/action/auth'
import {getPlanById} from '../../../redux/action/plan'
import DeleteCardModal from './modal/DeleteCardModal'
import PaywallModal from './modal/PaywallModal'
import EnhancedPaywallModal from './modal/EnhancedPaywallModal'
import FolderModal from './modal/FolderModal'
import timeSince from '../../../utils/timesince'
import {Flow} from '../../modules/cardform/components/editors/WalkthroughSteps'
import {generatePopup} from '../../../utils/popup'
import {Button} from 'react-bootstrap'
import {getProducts} from '../../../redux/action/api'
import {getFunctions, httpsCallable} from 'firebase/functions'

const DashboardPage: FC = () => {
  const currentPage = 1
  const itemsPerPage = 50 // Number of items to display per page
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('delete')
  const [cardId, setCardId] = useState('')
  const [currCard, setCard] = useState({})
  const Allmarkerdata = useSelector((state: any) => state.Card?.UserMarker)
  const Allcarddata = useSelector((state: any) => state.Card?.UserCard)
  const [Allcard, setAllcard] = useState<any>([]) //tracks Allcarddata and prevents manipulating global state
  const navigate = useNavigate()
  const [pname, setPname] = useState('')
  const userId = useSelector((state: any) => state._id)
  const userdata = useSelector((state: any) => state.Auth?.authProfile?.userData)
  const {userPermissions, isAdminMode, adminPermissionMode} = useSelector(
    (state: any) => state.Account
  )
  const token = localStorage.getItem('userId')
  
  // Paywall state
  const [showPaywall, setShowPaywall] = useState(false)
  const [paywallData, setPaywallData] = useState<{
    experiences: any[]
    trialDaysRemaining: number
    sceneCount: number
    isOnActivate: boolean
  } | null>(null)
  const [isCheckingPermissions, setIsCheckingPermissions] = useState(false)
  const [isDeactivating, setIsDeactivating] = useState(false)
  
  // Track scene pending activation through paywall
  const [pendingActivationSceneId, setPendingActivationSceneId] = useState<string | null>(null)
  
  // Folder management state
  const [currentFolderPath, setCurrentFolderPath] = useState<string>('')
  const [showFolderModal, setShowFolderModal] = useState(false)
  const [folderSceneId, setFolderSceneId] = useState<string>('')
  
  // Firebase functions
  const functions = getFunctions()
  const checkSceneCreationPermission = httpsCallable(functions, 'checkSceneCreationPermission')
  const getActiveExperencesForPayment = httpsCallable(functions, 'getActiveExperencesForPayment')
  const createPaymentSetup = httpsCallable(functions, 'createPaymentSetup')
  const setupFirstExperiencePayment = httpsCallable(functions, 'setupFirstExperiencePayment')
  const cancelSceneSubscription = httpsCallable(functions, 'cancelSceneSubscription')
  const getBillingInfo = httpsCallable(functions, 'getBillingInfo')
  const reactivateSceneSubscription = httpsCallable(functions, 'reactivateSceneSubscription')

  // Check for admin privileges - either from permissions or admin mode
  const isAdminModeLocal = localStorage.getItem('isAdminMode') === 'true'
  const hasAdminPrivileges =
    userPermissions?.admin_experience_creation ||
    isAdminMode ||
    isAdminModeLocal ||
    userdata?.protected?.isAdmin ||
    false

  useEffect(() => {
    // this will fetch product data on dashboard, so the user doesn't have to wait on ProductMenu.tsx for page to load
    dispatch(getProducts())
  }, []) //runs on mount

  useEffect(() => {
    if (token) {
      dispatch(userProfile(token))
      dispatch(getPlanById(token))
      // setLoading(false) //unused, omitting for now
    } else {
      // setLoading(false) //unused, omitting for now
    }
  }, [token])

  useEffect(() => {
    if (Allcarddata) {
      setAllcard(Allcarddata)
    }
  }, [Allcarddata])

  const makeUrlId = (card) => {
    if (card?.protected?.isActive || userdata?.protected?.isAdmin || hasAdminPrivileges) {
      return card._id //this displays Standard.tsx and StandardAdmin.tsx
    } else {
        return card._id; // temporary fix for the issue where the marker ID is not being found
        //  because the marker is not getting created before we order a product.
    //   return findMarkerId(card._id) //this displays WalkthroughFull.tsx
    }
  }

  const findMarkerId = (sceneId) => {
    const markerMatch = Allmarkerdata.find((m) => m.sceneId === sceneId)
    console.log('markerMatch', markerMatch)
    if (markerMatch) {
      return `${markerMatch._id}-m` //the '-m' tells the Compile.tsx it's a marker ID
    } else {
      throw new Error('Error occurred when looking up marker ID or scene ID')
    }
  }

  const handleLinkClick = (link) => {
    // Reset any global state here before navigating
    // From what I've observed, navigating with window.location.href behaves like a page refresh, clearing out the state
    window.location.href = link
  }

  const handleGetAllCardsAndMarkers = () => {
    dispatch(getCards({currentPage, itemsPerPage, userId})).then((res) => {
      console.log('getCards res', res)
    })
    dispatch(getMarkers({})).then((res) => {
      console.log('getMarkers res', res)
    })
  }

  useEffect(() => {
    handleGetAllCardsAndMarkers()
  }, [currentPage, itemsPerPage, userId])

  // Handle experience activation with subscription check
  const handleActivateExperience = async (sceneId: string) => {
    try {
      setIsDeactivating(true)
      
      // Check if user is admin, B2B, or creator (exempt from subscriptions)
      if (userdata?.protected?.isAdmin || userdata?.protected?.isB2B || userdata?.protected?.isCreator) {
        // Direct activation for exempt users
        await activateExperienceDirectly(sceneId)
        return
      }
      
      // Check if user has payment method and existing subscriptions
      const billingResult = await getBillingInfo()
      const billingData = billingResult.data as any
      
      if (billingData.success) {
        // Check if there's a cancelled subscription for this scene with active period remaining
        const existingSubscription = billingData.subscriptions?.find((sub: any) => 
          sub.sceneId === sceneId && 
          sub.isCanceled && 
          sub.currentPeriodEnd && 
          sub.currentPeriodEnd > Date.now()
        )
        
        if (existingSubscription) {
          console.log('Found cancelled subscription with active period for scene:', sceneId, existingSubscription)
          // Reactivate the existing cancelled subscription
          try {
            const reactivateResult = await reactivateSceneSubscription({ sceneId })
            const reactivateData = reactivateResult.data as any
            
            if (reactivateData.success) {
              // Activate the experience after reactivation
              await activateExperienceDirectly(sceneId)
              generatePopup('success', 'Subscription reactivated and experience activated successfully!')
              return
            } else {
                console.log('Failed to reactivate subscription:', reactivateData)
              generatePopup('error', 'Failed to reactivate subscription. Please try again.')
              return
            }
          } catch (reactivateError: any) {
            console.log('Error reactivating subscription:', reactivateError)
            generatePopup('error', 'Error reactivating subscription. Please try again.')
            return
          }
        }
        
        const experienceToActivate = Allcard?.find((data) => data?._id === sceneId)
        setPendingActivationSceneId(sceneId)
        setPaywallData({
          experiences: [
            {
              id: sceneId,
              name: experienceToActivate?.name || 'Experience',
            },
          ],
          trialDaysRemaining: billingData?.trial?.daysRemaining || 0,
          sceneCount: 1,
          isOnActivate: true,
        })
        setShowPaywall(true)
        return
      } else {
        generatePopup('error', 'Error checking billing information. Please try again.')
      }
      
    } catch (error: any) {
      console.log('Error checking payment method:', error)
      generatePopup('error', 'Error checking payment information. Please try again.')
    } finally {
      setIsDeactivating(false)
    }
  }

  // Direct activation without subscription (for admin/B2B/creator users)
  const activateExperienceDirectly = async (sceneId: string) => {
    try {
      // Update local state
      const updatedData = Allcard?.map((data) => {
        if (data?._id === sceneId) {
          return {
            ...data, 
            protected: {
              ...data.protected,
              isActive: true
            }
          }
        } else {
          return data
        }
      })

      setAllcard(updatedData)
      
      // Update server - set scene as active
      await dispatch(updateCard({
        _id: sceneId,
        protected: {
          isActive: true,
          reactivatedAt: new Date().getTime()
        }
      }))
      
      handleGetAllCardsAndMarkers()
      generatePopup('success', 'Experience activated successfully!')
      
    } catch (error: any) {
      console.log('Error activating experience:', error)
      generatePopup('error', 'Failed to activate experience. Please try again.')
    }
  }

  const handleDelete: any = async (id: any) => {
    // Prevent multiple clicks
    if (isDeactivating) return
    
    try {
      setIsDeactivating(true)
      
      // If this is a deactivation, cancel the subscription first
      if (type === 'deactivate') {
        try {
          const result = await cancelSceneSubscription({ sceneId: cardId })
          const data = result.data as any
          
          if (!data.success) {
            generatePopup('error', data.message || 'Failed to cancel subscription')
            return
          }
          
          generatePopup('success', 'Subscription cancelled successfully')
        } catch (subscriptionError: any) {
          console.log('Error cancelling subscription:', subscriptionError)
          generatePopup('error', 'Failed to cancel subscription. Please try again.')
          return
        }
      }
      
      // Handle activation, deactivation, and deletion differently
      if (type === 'activate') {
        // For activation: check if user needs subscription first
        setOpen(false) // Close the activation confirmation modal
        await handleActivateExperience(cardId)
        
      } else if (type === 'deactivate') {
        // For deactivation: only set protected.isActive to false
        const updatedData = Allcard?.map((data) => {
          if (data?._id === cardId) {
            return {
              ...data, 
              protected: {
                ...data.protected,
                isActive: false
              }
            }
          } else {
            return data
          }
        })

        setAllcard(updatedData)
        setOpen(false)
        
        // Update server - set scene as inactive (not deleted)
        dispatch(updateCard({
          _id: cardId,
          protected: {
            isActive: false,
            deactivatedAt: new Date().getTime()
          }
        })).then(() => {
          handleGetAllCardsAndMarkers()
        })
        
      } else {
        // For deletion: set isDeleted to true (existing behavior)
        const updatedData = Allcard?.map((data) => {
          if (data?._id === cardId) {
            return {...data, isDeleted: true}
          } else {
            return data
          }
        })

        setAllcard(updatedData)
        setOpen(false)
        
        // Update server
        dispatch(deleteCard(cardId)).then(() => {
          handleGetAllCardsAndMarkers()
          dispatch(getDeletedCards())
        })
      }
      
    } catch (error: any) {
      console.log('Error in handleDelete:', error)
      generatePopup('error', 'An error occurred. Please try again.')
    } finally {
      setIsDeactivating(false)
    }
  }

  const handleRename: any = () => {
    let card = {}
    const updatedData = Allcard?.map((data) => {
      if (data?._id === cardId) {
        card = {...data, name: pname}
        return card
      } else {
        return data
      }
    })

    setAllcard(updatedData)
    setOpen(false)
    dispatch(updateCard(card)).then(() => {
      handleGetAllCardsAndMarkers()
    })
  }

  const handleTextChange = (value) => {
    setPname(value)
  }

  const handleOpen = (id: any, type: string) => {
    setOpen(true)
    setType(type)
    setCardId(id)
    let card = Allcard?.filter((data) => data?._id === id)
    setCard(card[0])
    if (card?.name) {
      setPname(card?.name)
    } else {
      setPname('')
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const duplicateProject = async (scene) => {
    await dispatch(copyFiles({sceneId: scene._id}))
    handleGetAllCardsAndMarkers()
  }

  const [sortType, setSortType] = useState('createdAt')

  const sortByDescending = (a, b) => (a[sortType] > b[sortType] ? 1 : -1)
  const sortByAscending = (a, b) => (a[sortType] < b[sortType] ? 1 : -1)

  const useSortingFilter = (a, b) => {
    switch (sortType) {
      case 'createdAt':
      case 'updatedAt':
        return sortByAscending(a, b)
      case 'name':
      default:
        return sortByDescending(a, b)
    }
  }

  const handleCreateExperience = async () => {
    // Admin users can always create experiences
    if (hasAdminPrivileges) {
      navigate(`/vcard/compiler/scene/new`)
      return
    }

    setIsCheckingPermissions(true)
    
    try {
      // Check if user can create a scene
      const permissionResult = await checkSceneCreationPermission()
      const permissionData = permissionResult.data as any
      console.log('permissionData', permissionData)
      
      if (permissionData.canCreate && !permissionData.requiresPreviousPayment) {
        // User can create scene normally
        navigate(`/vcard/compiler/scene/new`)
      } else if (permissionData.requiresPreviousPayment) {
        // Need to set up payment for first experience
        const scenesResult = await getActiveExperencesForPayment()
        const experienceData = scenesResult.data as any
        
        if (experienceData.needsPaymentSetup) {
          setPaywallData({
            experiences: experienceData.scenesThatNeedPayment,
            trialDaysRemaining: experienceData.trialDaysRemaining,
            sceneCount: experienceData.sceneCount,
            isOnActivate: false
          })
          setShowPaywall(true)
        } else {
          // Shouldn't happen, but fallback
          navigate(`/vcard/compiler/scene/new`)
        }
      } else {
        // User can't create scene for other reasons
        generatePopup('error', permissionData.reason || 'Cannot create new experience at this time')
      }
    } catch (error) {
      console.error('Error checking scene creation permissions:', error)
      generatePopup('error', 'Error checking permissions. Please try again.')
    } finally {
      setIsCheckingPermissions(false)
    }
  }

  const handlePaywallComplete = async (paymentData: { success: boolean }) => {
    const wasActivation = paywallData?.isOnActivate
    const sceneIdToActivate = pendingActivationSceneId
    
    try {
      if (!paymentData.success) {
        generatePopup('error', 'Payment setup failed. Please try again.')
        return
      }
      
      setShowPaywall(false)
      
      if (wasActivation) {
        if (sceneIdToActivate) {
          await activateExperienceDirectly(sceneIdToActivate)
        } else {
          generatePopup('error', 'Unable to activate experience. Please try again.')
        }
      } else {
        generatePopup('success', 'Payment setup complete! You can now create additional experiences.')
        navigate(`/vcard/compiler/scene/new`)
        handleGetAllCardsAndMarkers()
      }
    } catch (error) {
      console.error('Error setting up payment:', error)
      generatePopup('error', 'Payment setup failed. Please try again.')
    } finally {
      setPaywallData(null)
      if (wasActivation) {
        setPendingActivationSceneId(null)
      }
    }
  }

  const handlePaywallCancel = () => {
    setShowPaywall(false)
    setPaywallData(null)
    setPendingActivationSceneId(null)
  }

  // Folder management functions
  const getAllFolders = (): string[] => {
    const folders = new Set<string>()
    Allcard?.forEach((card) => {
      if (card?.folder_name) {
        // Add all parent folders for nested structure
        const parts = card.folder_name.split('/')
        let currentPath = ''
        parts.forEach((part, idx) => {
          currentPath = idx === 0 ? part : `${currentPath}/${part}`
          folders.add(currentPath)
        })
      }
    })
    return Array.from(folders).sort()
  }

  const getAvailableFoldersForMove = (): string[] => {
    const allFolders = getAllFolders()
    // Filter out folders that are within the current folder path
    return allFolders.filter(folder => {
      if (!currentFolderPath) return true
      return !folder.startsWith(currentFolderPath + '/')
    })
  }

  const getImmediateSubfolders = (folderPath: string): string[] => {
    const folders = new Set<string>()
    const prefix = folderPath ? `${folderPath}/` : ''
    
    Allcard?.forEach((card) => {
      if (card?.folder_name) {
        if (folderPath) {
          // Looking for subfolders of current folder
          if (card.folder_name.startsWith(prefix)) {
            const remaining = card.folder_name.substring(prefix.length)
            const nextFolder = remaining.split('/')[0]
            if (nextFolder) {
              folders.add(`${prefix}${nextFolder}`)
            }
          }
        } else {
          // Looking for root level folders
          const firstFolder = card.folder_name.split('/')[0]
          folders.add(firstFolder)
        }
      }
    })
    
    return Array.from(folders).sort()
  }

  const getScenesInCurrentFolder = () => {
    return Allcard?.filter((card) => {
      if (!card || card.isDeleted) return false
      
      const cardFolder = card.folder_name || ''
      
      if (!currentFolderPath) {
        // Root level: only show scenes WITHOUT any folder assignment
        return !cardFolder
      } else {
        // Inside a folder: show scenes that are directly in this folder
        return cardFolder === currentFolderPath
      }
    })
  }

  const handleOpenFolderModal = (sceneId: string) => {
    setFolderSceneId(sceneId)
    setShowFolderModal(true)
  }

  const handleCloseFolderModal = () => {
    setShowFolderModal(false)
    setFolderSceneId('')
  }

  const handleAddToFolder = async (folderPath: string) => {
    try {
      const scene = Allcard?.find((card) => card._id === folderSceneId)
      if (!scene) return

      // Update server first
      await dispatch(updateCard({
        _id: folderSceneId,
        folder_name: folderPath
      }))
      
      // Refresh data from server to ensure consistency
      await handleGetAllCardsAndMarkers()
      generatePopup('success', 'Experience moved to folder successfully!')
      
    } catch (error: any) {
      console.log('Error moving to folder:', error)
      generatePopup('error', 'Failed to move experience to folder. Please try again.')
    }
  }

  const handleMoveToRoot = async (sceneId: string) => {
    try {
      // Check if this is the last experience in the current folder
      const scenesInFolder = getScenesInCurrentFolder()
      const willBeEmpty = scenesInFolder?.length === 1 && scenesInFolder[0]._id === sceneId
      
      // Update server - remove folder_name
      await dispatch(updateCard({
        _id: sceneId,
        folder_name: ''
      }))
      
      // Refresh data from server to ensure consistency
      await handleGetAllCardsAndMarkers()
      
      // If folder is now empty, navigate back to root
      if (willBeEmpty && currentFolderPath) {
        setCurrentFolderPath('')
      }
      
      generatePopup('success', 'Experience moved to root successfully!')
      
    } catch (error: any) {
      console.log('Error moving to root:', error)
      generatePopup('error', 'Failed to move experience to root. Please try again.')
    }
  }

  const handleNavigateToFolder = (folderPath: string) => {
    setCurrentFolderPath(folderPath)
  }

  const handleNavigateUp = () => {
    if (!currentFolderPath) return
    const parts = currentFolderPath.split('/')
    parts.pop()
    setCurrentFolderPath(parts.join('/'))
  }

  const getFolderDisplayName = (fullPath: string): string => {
    const parts = fullPath.split('/')
    return parts[parts.length - 1]
  }

  return (
    <>
      {/* Breadcrumb Navigation */}
      {currentFolderPath && (
        <div className='m-2 p-3 bg-light rounded d-flex align-items-center gap-2'>
          <Button 
            variant='link' 
            className='p-0 text-decoration-none'
            onClick={() => setCurrentFolderPath('')}
          >
            <i className='fas fa-home'></i> Home
          </Button>
          {currentFolderPath.split('/').map((folder, idx, arr) => {
            const path = arr.slice(0, idx + 1).join('/')
            const isLast = idx === arr.length - 1
            return (
              <React.Fragment key={idx}>
                <span>/</span>
                {isLast ? (
                  <strong>{folder}</strong>
                ) : (
                  <Button 
                    variant='link' 
                    className='p-0 text-decoration-none'
                    onClick={() => setCurrentFolderPath(path)}
                  >
                    {folder}
                  </Button>
                )}
              </React.Fragment>
            )
          })}
          <Button 
            variant='outline-secondary' 
            size='sm' 
            className='ms-auto'
            onClick={handleNavigateUp}
          >
            <i className='fas fa-arrow-up'></i> Back
          </Button>
        </div>
      )}
      
      {Allcard.length > 1 && (
        <div className='m-2 d-flex flex-row align-items-center justify-content-end gap-2'>
          Sort By:
          <Button variant='secondary' className='btn-sm' onClick={() => setSortType('name')}>
            Name
          </Button>
          <Button variant='secondary' className='btn-sm' onClick={() => setSortType('updatedAt')}>
            Last Updated
          </Button>
          <Button variant='secondary' className='btn-sm' onClick={() => setSortType('createdAt')}>
            Date Created
          </Button>
        </div>
      )}
      <div className='row w-100 m-auto relative py-5'>
          <div className='col-12 col-md-4 col-lg-3'>
            <div
              style={{cursor: isCheckingPermissions ? 'wait' : 'pointer'}}
              onClick={isCheckingPermissions ? undefined : handleCreateExperience}
            >
              <div className='w-100 h-250px border rounded shadow-sm  d-flex flex-column justify-content-center align-items-center'>
                <svg
                  width='114'
                  height='72'
                  viewBox='0 0 114 72'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <rect width='100' height='57.1429' rx='6' fill='#E4E4E4' />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M33.2857 41.4286C34.6263 41.4286 35.7143 40.3406 35.7143 39V19.5715C35.7143 18.2309 34.6263 17.1429 33.2857 17.1429H13.8571C12.5166 17.1429 11.4286 18.2309 11.4286 19.5715V39C11.4286 40.3406 12.5166 41.4286 13.8571 41.4286H33.2857ZM48.1428 22H81.8571C83.1977 22 84.2857 20.912 84.2857 19.5715C84.2857 18.2309 83.1977 17.1429 81.8571 17.1429H48.1428C46.8023 17.1429 45.7143 18.2309 45.7143 19.5715C45.7143 20.912 46.8023 22 48.1428 22ZM48.1428 30.5714H81.8571C83.1977 30.5714 84.2857 29.4834 84.2857 28.1428C84.2857 26.8022 83.1977 25.7142 81.8571 25.7142H48.1428C46.8023 25.7142 45.7143 26.8022 45.7143 28.1428C45.7143 29.4834 46.8023 30.5714 48.1428 30.5714ZM71.8571 39.1429H48.1428C46.8023 39.1429 45.7143 38.0549 45.7143 36.7143C45.7143 35.3738 46.8023 34.2858 48.1428 34.2858H71.8571C73.1977 34.2858 74.2857 35.3738 74.2857 36.7143C74.2857 38.0549 73.1977 39.1429 71.8571 39.1429Z'
                    fill='#C3C3C3'
                  />
                  <circle
                    cx='95.5'
                    cy='53.5'
                    r='17.5'
                    fill='#D9D9D9'
                    stroke='white'
                    strokeWidth='2'
                  />
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M101.6 52.4H97.6V48.4C97.6 48.16 97.44 48 97.2 48H94.8C94.56 48 94.4 48.16 94.4 48.4V52.4H90.4C90.16 52.4 90 52.56 90 52.8V55.2C90 55.44 90.16 55.6 90.4 55.6H94.4V59.6C94.4 59.84 94.56 60 94.8 60H97.2C97.44 60 97.6 59.84 97.6 59.6V55.6H101.6C101.84 55.6 102 55.44 102 55.2V52.8C102 52.56 101.84 52.4 101.6 52.4Z'
                    fill='white'
                  />
                </svg>
                <div className='text-center my-4 font-dark1'>
                  {isCheckingPermissions ? 'Checking permissions...' : 'Create New Experience'}
                </div>
              </div>
            </div>
          </div>
        
        {/* Render Folders First */}
        {getImmediateSubfolders(currentFolderPath).map((folderPath, idx) => {
          const displayName = getFolderDisplayName(folderPath)
          const folderScenes = Allcard?.filter((card) => 
            !card?.isDeleted && 
            card?.folder_name?.startsWith(folderPath)
          )
          const sceneCount = folderScenes?.length || 0
          
          return (
            <div className='col-12 col-md-4 col-lg-3' key={`folder-${idx}`}>
              <div 
                className='w-100 h-250px position-relative border rounded shadow-sm d-flex flex-column justify-content-center align-items-center p-15'
                style={{cursor: 'pointer', backgroundColor: '#f8f9fa'}}
                onClick={() => handleNavigateToFolder(folderPath)}
              >
                <svg
                  width='100'
                  height='80'
                  viewBox='0 0 100 80'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M10 15C10 11.6863 12.6863 9 16 9H38L48 19H84C87.3137 19 90 21.6863 90 25V65C90 68.3137 87.3137 71 84 71H16C12.6863 71 10 68.3137 10 65V15Z'
                    fill='#FDB022'
                  />
                  <path
                    d='M10 25C10 21.6863 12.6863 19 16 19H84C87.3137 19 90 21.6863 90 25V65C90 68.3137 87.3137 71 84 71H16C12.6863 71 10 68.3137 10 65V25Z'
                    fill='#FDCB68'
                  />
                </svg>
                <div className='text-center my-3 font-weight-bold' style={{fontSize: '14px'}}>
                  {displayName}
                </div>
                <div className='text-muted' style={{fontSize: '12px'}}>
                  {sceneCount} experience{sceneCount !== 1 ? 's' : ''}
                </div>
              </div>
            </div>
          )
        })}
        
        {/* Render Scenes in Current Folder */}
        {getScenesInCurrentFolder()?.sort(useSortingFilter)?.map((card, i) => {
          if (!card?.isDeleted) {
            return (
              <div className='col-12 col-md-4 col-lg-3' key={i}>
                <div className='w-100 h-250px position-relative border rounded  d-flex flex-column justify-content-center align-items-center p-15'>
                  {/* Note: with the introduction of FlowTypes, cards are only accessed through their linked marker IDs */}
                  <div
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                try {
                                  handleLinkClick(
                                    `/vcard/compiler/scene/${makeUrlId(card)}`
                                  )
                                } catch (error: any) {
                                  generatePopup(
                                    'error',
                                    error.message
                                  )
                                }
                            }}
                        
                    
                  >
                    <img
                      style={{
                        filter: 'drop-shadow(5px 5px 4px #222222)',
                        maxHeight: '180px',
                        opacity: card?.protected?.isActive ? '1.0' : '0.4',
                      }}
                      className='h-100 w-100'
                      src={card?.previewUrl}
                      alt=''
                    />
                    <div style={{top: '6px', left: '6px'}} className='position-absolute'>
                      {card?.protected?.isActive ? (
                        <svg
                          width='45'
                          height='22'
                          viewBox='0 0 45 22'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect width='45' height='22' rx='11' fill='green' fillOpacity='0.7' />
                          <path
                            fill='white'
                            d='M11.299 16V6.77H12.391V14.934H17.019V16H11.299ZM18.7363 9.11H19.8023V16H18.7363V9.11ZM18.7103 8.031V6.796H19.8283V8.031H18.7103ZM27.5627 9.11L25.0407 16H23.7147L21.1927 9.11H22.3367L24.3777 14.882L26.4187 9.11H27.5627ZM28.132 12.555C28.132 10.371 29.367 8.954 31.278 8.954C32.812 8.954 34.151 9.981 34.268 12.412L34.281 12.893H29.263C29.367 14.31 30.082 15.142 31.278 15.142C32.032 15.142 32.708 14.7 33.02 13.972L34.164 14.05C33.761 15.35 32.604 16.156 31.278 16.156C29.367 16.156 28.132 14.739 28.132 12.555ZM29.289 11.944H33.111C32.916 10.488 32.136 9.968 31.278 9.968C30.173 9.968 29.458 10.696 29.289 11.944Z'
                          />
                        </svg>
                      ) : (
                        <svg
                          width='82'
                          height='22'
                          viewBox='0 0 82 22'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect width='82' height='22' rx='11' fill='black' fillOpacity='0.3' />
                          <path
                            d='M11.467 6.77H12.988L17.564 14.713V6.77H18.656V16H17.07L12.559 8.187V16H11.467V6.77ZM23.3591 16.156C21.4481 16.156 20.2131 14.739 20.2131 12.555C20.2131 10.371 21.4481 8.954 23.3591 8.954C25.2701 8.954 26.5051 10.371 26.5051 12.555C26.5051 14.739 25.2701 16.156 23.3591 16.156ZM21.3311 12.555C21.3311 14.167 22.0721 15.142 23.3591 15.142C24.6331 15.142 25.3871 14.167 25.3871 12.555C25.3871 10.943 24.6331 9.968 23.3591 9.968C22.0721 9.968 21.3311 10.943 21.3311 12.555ZM28.5181 7.55H29.5841V9.11H31.4171V10.059H29.5841V14.18C29.5841 14.765 29.8701 15.051 30.4161 15.051H31.4041V16H30.4161C29.1941 16 28.5181 15.35 28.5181 14.18V10.059H27.5041V9.11H28.5181V7.55ZM35.8945 11.138C36.1675 9.799 37.2335 8.954 38.7025 8.954C40.4835 8.954 41.4715 9.994 41.4715 11.84V14.609C41.4715 14.921 41.6015 15.051 41.9005 15.051H42.1735V16H41.7185C41.0165 16 40.4055 15.766 40.4185 14.921C40.1195 15.571 39.3395 16.156 38.2475 16.156C36.8825 16.156 35.7775 15.428 35.7775 14.206C35.7775 12.789 36.8565 12.425 38.3645 12.126L40.4055 11.736C40.3925 10.54 39.8335 9.968 38.7025 9.968C37.8185 9.968 37.2335 10.423 37.0255 11.229L35.8945 11.138ZM36.8955 14.206C36.8955 14.765 37.3765 15.22 38.3905 15.207C39.5345 15.207 40.4315 14.401 40.4315 12.802V12.685L38.7805 12.971C37.7535 13.153 36.8955 13.231 36.8955 14.206ZM48.0034 11.411C47.8474 10.501 47.1064 9.968 46.2614 9.968C44.9744 9.968 44.2334 10.943 44.2334 12.555C44.2334 14.167 44.9744 15.142 46.2614 15.142C47.1454 15.142 47.8994 14.557 48.0554 13.569L49.1864 13.634C48.9654 15.194 47.7304 16.156 46.2614 16.156C44.3504 16.156 43.1154 14.739 43.1154 12.555C43.1154 10.371 44.3504 8.954 46.2614 8.954C47.6784 8.954 48.9394 9.864 49.1214 11.333L48.0034 11.411ZM51.065 7.55H52.131V9.11H53.964V10.059H52.131V14.18C52.131 14.765 52.417 15.051 52.963 15.051H53.951V16H52.963C51.741 16 51.065 15.35 51.065 14.18V10.059H50.051V9.11H51.065V7.55ZM55.5684 9.11H56.6344V16H55.5684V9.11ZM55.5424 8.031V6.796H56.6604V8.031H55.5424ZM64.3948 9.11L61.8728 16H60.5468L58.0248 9.11H59.1688L61.2098 14.882L63.2508 9.11H64.3948ZM64.964 12.555C64.964 10.371 66.199 8.954 68.11 8.954C69.644 8.954 70.983 9.981 71.1 12.412L71.113 12.893H66.095C66.199 14.31 66.914 15.142 68.11 15.142C68.864 15.142 69.54 14.7 69.852 13.972L70.996 14.05C70.593 15.35 69.436 16.156 68.11 16.156C66.199 16.156 64.964 14.739 64.964 12.555ZM66.121 11.944H69.943C69.748 10.488 68.968 9.968 68.11 9.968C67.005 9.968 66.29 10.696 66.121 11.944Z'
                            fill='white'
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div
                    style={{top: '6px', right: '1px'}}
                    className='position-absolute drop-arrow-hide'
                  >
                    <button
                      className='bg-transparent border-0 dropdown-toggle dropdown-toggle-split more-hover'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <div className='svg-container'>
                        <svg
                          className='svg-icon'
                          width='18'
                          height='4'
                          viewBox='0 0 18 4'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M0.599609 2.00002C0.599609 1.1162 1.31578 0.400024 2.19961 0.400024C3.08344 0.400024 3.79961 1.1162 3.79961 2.00002C3.79961 2.88385 3.08344 3.60002 2.19961 3.60002C1.31578 3.60002 0.599609 2.88385 0.599609 2.00002Z'
                            fill='#444444'
                          />
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M7.39941 2.00002C7.39941 1.1162 8.11559 0.400024 8.99941 0.400024C9.88324 0.400024 10.5994 1.1162 10.5994 2.00002C10.5994 2.88385 9.88324 3.60002 8.99941 3.60002C8.11559 3.60002 7.39941 2.88385 7.39941 2.00002Z'
                            fill='#444444'
                          />
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M14.1992 2.00002C14.1992 1.1162 14.9154 0.400024 15.7992 0.400024C16.683 0.400024 17.3992 1.1162 17.3992 2.00002C17.3992 2.88385 16.683 3.60002 15.7992 3.60002C14.9154 3.60002 14.1992 2.88385 14.1992 2.00002Z'
                            fill='#444444'
                          />
                        </svg>
                        <svg
                          className='overlay-icon'
                          width='30'
                          height='30'
                          viewBox='0 0 30 30'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle cx='15' cy='15' r='15' fill='black' fillOpacity='0' />
                        </svg>
                      </div>
                    </button>
                    <ul className='dropdown-menu p-4 mt-3 w-100 px-3'>
                      <li
                        className='cursor-pointer'
                        onClick={() => handleOpen(card?._id, 'rename')}
                      >
                        <div
                          className='d-flex gap-2 align-items-center'
                          style={{width: 'max-content'}}
                        >
                          <svg
                            width='16px'
                            height='16px'
                            viewBox='0 0 16 16'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path d='M13.337 3.997h-0.667v1.333h0.667v5.333h-0.667v1.333h0.667c0.735 0 1.333 -0.598 1.333 -1.333v-5.333c0 -0.735 -0.599 -1.333 -1.333 -1.333m-9.333 2.667H10v2.667H4.003z' />
                            <path d='M11.337 11.997V2.667H13.333V1.333h-5.333v1.333h2.003v1.33h-7.333c-0.735 0 -1.333 0.598 -1.333 1.333v5.333c0 0.735 0.598 1.333 1.333 1.333h7.333V13.333H8v1.333h5.333v-1.333h-1.997zm-8.667 -1.333v-5.333h7.333v5.333z' />
                          </svg>
                          Rename
                        </div>
                      </li>
                      <li
                        className='pt-2 cursor-pointer'
                        onClick={() => navigate(`/analytics/overview/${card._id}-s`)}
                      >
                        <div
                          className='d-flex gap-2 align-items-center'
                          style={{width: 'max-content'}}
                        >
                          <svg
                            width='16'
                            height='16'
                            viewBox='0 0 512 512'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path d='M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z' />
                          </svg>
                          View Analytics
                        </div>
                      </li>
                      <li
                        className='pt-2 cursor-pointer'
                        onClick={() => handleOpenFolderModal(card?._id)}
                      >
                        <div
                          className='d-flex gap-2 align-items-center'
                          style={{width: 'max-content'}}
                        >
                          <i
                            className='fas fa-folder'
                            style={{fontSize: '15px', marginRight: '4px'}}
                          ></i>
                          Add to Folder
                        </div>
                      </li>
                      {card?.folder_name && (
                        <li
                          className='pt-2 cursor-pointer'
                          onClick={() => handleMoveToRoot(card?._id)}
                        >
                          <div
                            className='d-flex gap-2 align-items-center'
                            style={{width: 'max-content'}}
                          >
                            <i
                              className='fas fa-home'
                              style={{fontSize: '15px', marginRight: '4px'}}
                            ></i>
                            Move to Root
                          </div>
                        </li>
                      )}
                      {card?.protected?.isActive ? (
                        <li
                          className='pt-2 cursor-pointer'
                          onClick={() => handleOpen(card?._id, 'deactivate')}
                        >
                          <div className='d-flex gap-2 align-items-center'>
                            <i
                              className='fas fa-ban'
                              style={{color: 'red', fontSize: '15px', marginRight: '4px'}}
                            ></i>
                            Deactivate
                          </div>
                        </li>
                      ) : (
                        <>
                          <li
                            className='pt-2 cursor-pointer'
                            onClick={() => handleOpen(card?._id, 'activate')}
                          >
                            <div className='d-flex gap-2 align-items-center'>
                              <i
                                className='fas fa-play'
                                style={{color: 'green', fontSize: '15px', marginRight: '4px'}}
                              ></i>
                              Activate
                            </div>
                          </li>
                          <li
                            className='pt-2 cursor-pointer'
                            onClick={() => handleOpen(card?._id, 'delete')}
                          >
                            <div className='d-flex gap-2 align-items-center'>
                              <i
                                className='fas fa-trash'
                                style={{color: 'red', fontSize: '15px', marginRight: '4px'}}
                              ></i>
                              Delete
                            </div>
                          </li>
                        </>
                      )}
                      {hasAdminPrivileges && card?.protected?.isActive && (
                        <li className='pt-2 cursor-pointer' onClick={() => duplicateProject(card)}>
                          <div
                            className='d-flex gap-2 align-items-center'
                            style={{width: 'max-content'}}
                          >
                            <svg
                              width='16'
                              height='16'
                              viewBox='0 0 512 512'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path d='M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z' />
                            </svg>
                            Duplicate
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div>
                  <div className='row'>
                    <div
                      style={{fontSize: '11px', fontStyle: 'bold'}}
                      className='my-2 font-gray1 col-6'
                    >
                      {card?.name ? card.name : ('Project ' + (i + 1))}
                      {card?.scanCount ? (
                        <span
                          style={{
                            fontStyle: 'italic',
                            color: '#666',
                            marginLeft: '4px'
                          }}
                        >
                          ({card.scanCount} Scans)
                        </span>
                      ) : ""}
                    </div>
                    <div
                      style={{fontSize: '11px', textAlign: 'right'}}
                      className='my-2 font-gray1 col-6'
                    >
                      {timeSince(card.updatedAt)}
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })}

        {/* {activePlan?.length === 0 && <PaymentWarning userData={userdata} />} */}
        <DeleteCardModal
          open={open}
          type={type}
          card={currCard}
          handleClose={handleClose}
          del={handleDelete}
          rename={handleRename}
          rtext={handleTextChange}
          pname={pname}
          deleteType='experience'
          isLoading={isDeactivating}
        />
        
        {/* Paywall Modal */}
        {showPaywall && (
          <EnhancedPaywallModal
            show={showPaywall}
            onHide={handlePaywallCancel}
            paywallData={paywallData}
            onPaymentComplete={handlePaywallComplete}
          />
        )}
        
        {/* Folder Modal */}
        <FolderModal
          open={showFolderModal}
          handleClose={handleCloseFolderModal}
          existingFolders={getAvailableFoldersForMove()}
          currentFolder={currentFolderPath}
          onSelectFolder={handleAddToFolder}
          sceneName={
            Allcard?.find((card) => card._id === folderSceneId)?.name || 'Experience'
          }
        />
        
      </div>
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
